import { render } from "./SalarySplit.vue?vue&type=template&id=d3b6eace&scoped=true&ts=true"
import script from "./SalarySplit.vue?vue&type=script&lang=ts"
export * from "./SalarySplit.vue?vue&type=script&lang=ts"

import "./SalarySplit.vue?vue&type=style&index=0&id=d3b6eace&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3b6eace"]])

export default __exports__